import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import api from '../services/api';

function ParticipantList({ discussionId, creatorId, isPublic, currentUserId, prompt }) {
  const [participants, setParticipants] = useState([]);
const [bannedUsers, setBannedUsers] = useState([]); 
const [pendingInvitations, setPendingInvitations] = useState([]);
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const token = localStorage.getItem('token');
//const currentUserId = localStorage.getItem('_id'); 
const { t } = useTranslation();

  useEffect(() => {
    // Fonction pour récupérer les participants
    const fetchParticipants = async () => {
      try {
        const response = await api.get(`${API_URL}/api/discussions/${discussionId}/participants`);
        setParticipants(response.data.participants);
	 setBannedUsers(response.data.bannedUsers || []); 
	setPendingInvitations(response.data.pendingInvitations || []);
      } catch (error) {
        console.error('Erreur lors de la récupération des participants', error);
      }
    };

    fetchParticipants();
  }, [discussionId]);

const handleBan = async (userId) => {
const { alert, confirm} = prompt;
const confirmation = await confirm(t('participants.alertdelete'));
if (confirmation) {
    try {
      await api.post(`${API_URL}/api/discussions/${discussionId}/ban`, { userId });

      // Mise à jour instantanée
      setParticipants(prev => prev.filter(p => p._id !== userId));
      setBannedUsers(prev => [...prev, userId]);
const { alert, confirm} = prompt;
      await alert(t('participants.deletesucces'));
    } catch (error) {
      console.error("Erreur lors de la radiation :", error);
      alert("Impossible de radier cet utilisateur");
    }
}
  };

 const navigate = useNavigate(); // Pour naviguer vers le profil utilisateur

  const goToUserProfile = (userId) => {
    navigate(`/profile/${userId}`); // Navigue vers la page de profil de l'utilisateur
  };

const getInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
};

   return (
    <div style={{ padding: '1rem', background: 'var(--bg-color)', borderRadius: 10 }}>

  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
    <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: 'var(--title-color)' }}>
{!isPublic
    ? t('participants.participants')
    : t('participants.participants_public')}
        
    </h3>
    <span style={{ fontSize: 12, color: 'var(--input-color)', background: 'var(--card-bg)', padding: '2px 10px', borderRadius: 20, border: '1px solid var(--li-border-color)' }}>
      {participants.length} {!isPublic
    ? t('participants.membres')
    : t('participants.membres_public')}

    </span>
  </div>

  <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
    {participants.map((participant) => {
      const isCreator = participant._id === creatorId._id;
      const alreadyBanned = bannedUsers.includes(participant._id);
      const canBan = currentUserId === creatorId._id && !isCreator && isPublic && !alreadyBanned;

      return (
        <li key={participant._id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, border: '1px solid var(--li-border-color)', background: 'var(--li-bg-color)' }}>

          {/* Avatar */}
          <img
            src={participant.profileImage
              ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${participant._id}?token=${token}&type=image&thumb=true&profile=true&t=${participant.profileImageUpdatedAt}`
              : `${API_URL}/uploads/default-profile.png`}
            alt={participant.username}
            onClick={() => goToUserProfile(participant._id)}
            style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, cursor: 'pointer', border: '1px solid var(--li-border-color)' }}
          />

          {/* Nom + badge */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, overflow: 'hidden' }}>
            <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-color)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {participant.username}
            </span>
            {isCreator ? (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 10, fontWeight: 600, padding: '1px 7px', borderRadius: 20, width: 'fit-content', background: '#fff3cd', color: '#856404', border: '1px solid #ffc107' }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="#856404"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>
              
{!isPublic
    ? t('participants.createur')
    : t('participants.createur_public')}

              </span>
            ) : (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 10, fontWeight: 600, padding: '1px 7px', borderRadius: 20, width: 'fit-content', background: '#e8f4fd', color: '#0c5460', border: '1px solid #bee5eb' }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="#0c5460"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
{!isPublic
    ? t('participants.membre')
    : t('participants.membre_public')}

                
              </span>
            )}
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
            {/* Icône membre */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, borderRadius: 8, border: '1px solid var(--li-border-color)', background: 'var(--card-bg)' }} title={t('participants.membre')}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--discussion-creator)" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
            </div>

            {/* Bouton radier */}
            {canBan && (
              <button
                onClick={() => handleBan(participant._id)}
                style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '5px 10px', borderRadius: 8, border: 'none', background: 'var(--danger-bg)', color: '#fff', fontSize: 12, fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap' }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
                </svg>
                {t('participants.radier')}
              </button>
            )}
          </div>

        </li>
      );
    })}
  </ul>
{/* Section invités en attente */}
      {(pendingInvitations ?? []).length > 0 && (
        <div style={{ marginTop: 20 }}>

          {/* Séparateur + titre */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <div style={{ flex: 1, height: 1, background: 'var(--li-border-color)' }} />
            <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--date_message-color)', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 5 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
              {t('participants.en_attente')} ({pendingInvitations.length})
            </span>
            <div style={{ flex: 1, height: 1, background: 'var(--li-border-color)' }} />
          </div>

          <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
            {pendingInvitations.map(pending => (
              <li key={pending._id} style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 12px', borderRadius: 10,
                border: '1px dashed var(--li-border-color)',  // ← tirets pour distinguer
                background: 'var(--card-bg)', opacity: 0.85,
              }}>

                {/* Avatar */}
                {pending.profileImage ? (
                  <img
                    src={`${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${pending._id}?token=${token}&type=image&thumb=true&profile=true&t=${pending.profileImageUpdatedAt}`}
                    alt={pending.username}
                    style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: '1px dashed var(--li-border-color)', filter: 'grayscale(30%)' }}
                  />
                ) : (
                  <div style={{
                    width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 14, fontWeight: 600,
                    background: 'var(--border-color)', color: 'var(--text-color)',
                  }}>
                    {getInitials(pending.username)}
                  </div>
                )}

                {/* Nom + badge */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, overflow: 'hidden' }}>
                  <span style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-color)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {pending.username}
                  </span>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 10, fontWeight: 600, padding: '1px 7px', borderRadius: 20, width: 'fit-content', background: '#fff8e1', color: '#f57f17', border: '1px solid #ffe082' }}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#f57f17" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                    </svg>
                    {t('participants.invitation_envoyee')}
                  </span>
                </div>

              </li>
            ))}
          </ul>
</div>
   )} 
</div>
  );
}

export default ParticipantList;
